import type { BenefitSummary } from "@yutai/shared"
import { useMemo } from "react"
import { BenefitCardsSection } from "../benefit/BenefitCardsSection.js"
import { findSimilarBenefits } from "../benefit/findSimilarBenefits.js"
import styles from "./SimilarBenefitsSection.module.css"

interface Props {
  benefit: BenefitSummary
  allBenefits: BenefitSummary[]
}

export function SimilarBenefitsSection({ benefit, allBenefits }: Props) {
  const similar = useMemo(() => findSimilarBenefits(benefit, allBenefits), [benefit, allBenefits])

  if (similar.length === 0) return null

  return (
    <aside className={styles.region}>
      <BenefitCardsSection
        sectionId="similar-benefits-title"
        title="似ている銘柄"
        benefits={similar.map((item) => item.benefit)}
        cardBorderVariant="gradient"
      />
    </aside>
  )
}
